import { BRAND } from "./brand";

export interface INavbarItem {
  key: string;
  title: string;
  separator?: boolean;
  items?: INavbarItem[]
  icon?: string;
  url?: string;
}

/** MENU */

export const menu: INavbarItem[] = [
  { key: "documentation", title: "Documentation", items: [], url: BRAND.docsUrl },
  { key: "support", title: "Support", items: [], url: `${BRAND.supportUrl}/support` },
  { key: "settings", title: "Settings", items: [], url: "/settings/general/backoffice" }
]


/** SETTINGS */
export const settings: INavbarItem[] = [
  {
    key:"settings-global",
    title: "views.menu.settings_global",
    icon:"cog",
    items:[
      {
        title:"views.menu.settings_global_bo",
        key:"/settings/general/backoffice"
      },
      {
        title:"views.menu.settings_subscription_addons",
        key:"/settings/subscription-add-ons"
      }
    ]
  },
  // {
  //   key:"settings-admin",
  //   icon:"shield",
  //   title: "views.menu.settings_admin",
  //   items:[
  //     {
  //         title:"views.menu.settings_admin_elenco",
  //         key:"/settings/admin/users"
  //       },
  //   ]
  // }
]
